import { useContext } from 'react';
import { LoggerContext } from '../context/logger-context';

const useLogger = () => {
  const context = useContext(LoggerContext);
  if (!context) {
    throw new Error('useLogger must be used within a LoggerContext');
  }
  return context;
};
export default useLogger;
